import { IApplicationState } from '../../types/redux';

/**
 * Выбирает мету для списка статей
 */
export const selectArticleListMeta = ({ articleList }: IApplicationState) => articleList.meta;
